const url = {
  SECURITY: window.runtimeConfig.authWebSite,
  SECURITY_API_SERVER: window.runtimeConfig.authApiUrl,
  API_SERVER: window.runtimeConfig.authApiUrl,
  NEWTUBE_API_SERVER: window.runtimeConfig.fdApiUrl,
  TA_API_SERVER: window.runtimeConfig.ptApiUrl,
  PY_API_SERVER: window.runtimeConfig.pyApiUrl,
  RMS_API_SERVER: window.runtimeConfig.rmsApiUrl,
  WEBBFF_API_SERVER: window.runtimeConfig.webbffApiUrl,
  STAYFUN: window.runtimeConfig.stayFunWebSite,
  JOBHUB: window.runtimeConfig.jobHubWebSite,
  NEW_XE: window.runtimeConfig.newXEWebSite,
  NEW_XE_API_SERVER: window.runtimeConfig.newXEWebSiteApiUrl,
  PLATFORM_BFF_API_SERVER: window.runtimeConfig.platformBffApiUrl,
};

export default url;



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/configs/url.js
 **/